import React from 'react';
import CardHeader from '@mui/material/CardHeader';
import { css } from '@emotion/react';
import { getPaletteColor } from '@cd/rhf';
import { useTheme } from '@mui/material/styles';

const rootStyles = css({
	'.MuiTypography-root': {
		fontSize: '18px'
	},
	color: 'var(--color)',

	padding: '8px'
});

const CardHeaderCD = ({ color, ...rest }) => {
	const theme = useTheme();
	const finalColor = getPaletteColor(color, theme);
	return (
		<CardHeader
			css={rootStyles}
			style={{ '--color': finalColor }}
			{...rest}
		/>
	);
};
export default CardHeaderCD;
